import limitCalculation from './limit-calculation';
import calculateScenario from './calculate-scenario';
export default function runScenario(calculateMortgageInsurance, inputs) {
  var outputs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return limitCalculation(outputs, function (o) {
    return calculateScenario(calculateMortgageInsurance, inputs, o);
  }, 'suggestedPurchasePrice');
}